/**
 *
 * @param {string} name
 * @returns
 */

import key from "./key"

const url = `app/${key}`
//metadata
export const LOAD_RECORDS_META_DATA = `${url}/LOAD_RECORDS_META_DATA`
export const LOAD_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_RECORDS_META_DATA_SUCCESS`
export const LOAD_RECORDS_META_DATA_ERROR = `${url}/LOAD_RECORDS_META_DATA_ERROR`

//Special Instructions
export const LOAD_FOLLOWUP_LIST = `${url}/LOAD_FOLLOWUP_LIST`
export const LOAD_FOLLOWUP_LIST_SUCCESS = `${url}/LOAD_FOLLOWUP_LIST_SUCCESS`
export const LOAD_FOLLOWUP_LIST_ERROR = `${url}/LOAD_FOLLOWUP_LIST _ERROR`

export const ADD_FOLLOWUP = `${url}/ADD_FOLLOWUP`
export const ADD_FOLLOWUP_SUCCESS = `${url}/ADD_FOLLOWUP_SUCCESS`
export const ADD_FOLLOWUP_ERROR = `${url}/ADD_FOLLOWUP_ERROR`

export const UPDATE_FOLLOWUP = `${url}/UPDATE_FOLLOWUP`
export const UPDATE_FOLLOWUP_SUCCESS = `${url}/UPDATE_FOLLOWUP_SUCCESS`
export const UPDATE_FOLLOWUP_ERROR = `${url}/UPDATE_FOLLOWUP_ERROR`

export const LOAD_CHECK_LIST = `${url}/LOAD_CHECK_LIST`
export const LOAD_CHECK_LIST_SUCCESS = `${url}/LOAD_CHECK_LIST_SUCCESS`
export const LOAD_CHECK_LIST_ERROR = `${url}/LOAD_CHECK_LIST _ERROR`

export const LOAD_TEAM_SCHEDULE = `${url}/LOAD_TEAM_SCHEDULE`
export const LOAD_TEAM_SCHEDULE_SUCCESS = `${url}/LOAD_TEAM_SCHEDULE_SUCCESS`
export const LOAD_TEAM_SCHEDULE_ERROR = `${url}/LOAD_TEAM_SCHEDULE_ERROR`

export const LOAD_EC_FOLLOWUP_LIST = `${url}/LOAD_EC_FOLLOWUP_LIST`
export const LOAD_EC_FOLLOWUP_LIST_SUCCESS = `${url}/LOAD_EC_FOLLOWUP_LIST_SUCCESS`
export const LOAD_EC_FOLLOWUP_LIST_ERROR = `${url}/LOAD_EC_FOLLOWUP_LIST _ERROR`


export const LOAD_EC_APP = `${url}/LOAD_EC_APP`
export const LOAD_EC_APP_SUCCESS = `${url}/LOAD_EC_APP_SUCCESS`
export const LOAD_EC_APP_ERROR = `${url}/LOAD_EC_APP_ERROR`


export const LOAD_EC_EVENT = `${url}/LOAD_EC_EVENT`
export const LOAD_EC_EVENT_SUCCESS = `${url}/LOAD_EC_EVENT_SUCCESS`
export const LOAD_EC_EVENT_ERROR = `${url}/LOAD_EC_EVENT_ERROR`

export const LOAD_DELIVERABLES = `${url}/LOAD_DELIVERABLES`
export const LOAD_DELIVERABLES_SUCCESS = `${url}/LOAD_DELIVERABLES_SUCCESS`
export const LOAD_DELIVERABLES_ERROR = `${url}/LOAD_DELIVERABLES_ERROR`


export const LOAD_DELIVER_META_DATA = `${url}/LOAD_DELIVER_META_DATA`
export const LOAD_DELIVER_META_DATA_SUCCESS = `${url}/LOAD_DELIVER_META_DATA_SUCCESS`
export const LOAD_DELIVER_META_DATA_ERROR = `${url}/LOAD_DELIVER_META_DATA_ERROR`

export const LOAD_DELIVERABLE_STATUS = `${url}/LOAD_DELIVERABLE_STATUS`
export const LOAD_DELIVERABLE_STATUS_SUCCESS = `${url}/LOAD_DELIVERABLE_STATUS_SUCCESS`
export const LOAD_DELIVERABLE_STATUS_ERROR = `${url}/LOAD_DELIVERABLE_STATUS _ERROR`


export const LOAD_ISSUES = `${url}/LOAD_ISSUES`
export const LOAD_ISSUES_SUCCESS = `${url}/LOAD_ISSUES_SUCCESS`
export const LOAD_ISSUES_ERROR = `${url}/LOAD_ISSUES_ERROR`

export const LOAD_CALL_CRITERIA = `${url}/LOAD_CALL_CRITERIA`
export const LOAD_CALL_CRITERIA_SUCCESS = `${url}/LOAD_CALL_CRITERIA_SUCCESS`
export const LOAD_CALL_CRITERIA_ERROR = `${url}/LOAD_CALL_CRITERIA_ERROR`

export const LOAD_CALL_ACTIONS = `${url}/LOAD_CALL_ACTIONS`
export const LOAD_CALL_ACTIONS_SUCCESS = `${url}/LOAD_CALL_ACTIONS_SUCCESS`
export const LOAD_CALL_ACTIONS_ERROR = `${url}/LOAD_CALL_ACTIONS_ERROR`

export const LOAD_DELIVERABLE_TAG = `${url}/LOAD_DELIVERABLE_TAG`
export const LOAD_DELIVERABLE_TAG_SUCCESS = `${url}/LOAD_DELIVERABLE_TAG_SUCCESS`
export const LOAD_DELIVERABLE_TAG_ERROR = `${url}/LOAD_DELIVERABLE_TAG _ERROR`

export const ADD_ISSUES = `${url}/ADD_ISSUES`
export const ADD_ISSUES_SUCCESS = `${url}/ADD_ISSUES_SUCCESS`
export const ADD_ISSUES_ERROR = `${url}/ADD_ISSUES_ERROR`

export const  UPDATE_ISSUES = `${url}/ UPDATE_ISSUES`
export const  UPDATE_ISSUES_SUCCESS = `${url}/ UPDATE_ISSUES_SUCCESS`
export const  UPDATE_ISSUES_ERROR = `${url}/ UPDATE_ISSUES_ERROR`


export const  DELETE_ISSUES = `${url}/ DELETE_ISSUES`
export const  DELETE_ISSUES_SUCCESS = `${url}/ DELETE_ISSUES_SUCCESS`
export const  DELETE_ISSUES_ERROR = `${url}/ DELETE_ISSUES_ERROR`

export const LOAD_CALL_RECORDING = `${url}/LOAD_CALL_RECORDING`
export const LOAD_CALL_RECORDING_SUCCESS = `${url}/LOAD_CALL_RECORDING_SUCCESS`
export const LOAD_CALL_RECORDING_ERROR = `${url}/LOAD_CALL_RECORDING_ERROR`

export const  UPDATE_NOTES = `${url}/ UPDATE_NOTES`
export const  UPDATE_NOTES_SUCCESS = `${url}/ UPDATE_NOTES_SUCCESS`
export const  UPDATE_NOTES_ERROR = `${url}/ UPDATE_NOTES_ERROR`

//UPDATE_REVIEW
export const  UPDATE_REVIEW = `${url}/ UPDATE_REVIEW`
export const  UPDATE_REVIEW_SUCCESS = `${url}/ UPDATE_REVIEW_SUCCESS`
export const  UPDATE_REVIEW_ERROR = `${url}/ UPDATE_REVIEW_ERROR`

export const ADD_REVIEW = `${url}/ADD_REVIEW`
export const ADD_REVIEW_SUCCESS = `${url}/ADD_REVIEW_SUCCESS`
export const ADD_REVIEW_ERROR = `${url}/ADD_REVIEW_ERROR`


export const LOAD_REVIEW = `${url}/LOAD_REVIEW`
export const LOAD_REVIEW_SUCCESS = `${url}/LOAD_REVIEW_SUCCESS`
export const LOAD_REVIEW_ERROR = `${url}/LOAD_REVIEW_ERROR`


const constants = {
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,


  ADD_FOLLOWUP,
  ADD_FOLLOWUP_SUCCESS,
  ADD_FOLLOWUP_ERROR,

  UPDATE_FOLLOWUP,
  UPDATE_FOLLOWUP_SUCCESS,
  UPDATE_FOLLOWUP_ERROR,

  LOAD_FOLLOWUP_LIST,
  LOAD_FOLLOWUP_LIST_SUCCESS,
  LOAD_FOLLOWUP_LIST_ERROR,

  LOAD_CHECK_LIST,
  LOAD_CHECK_LIST_SUCCESS,
  LOAD_CHECK_LIST_ERROR,

  LOAD_TEAM_SCHEDULE,
  LOAD_TEAM_SCHEDULE_SUCCESS,
  LOAD_TEAM_SCHEDULE_ERROR,


  LOAD_EC_FOLLOWUP_LIST,
  LOAD_EC_FOLLOWUP_LIST_SUCCESS,
  LOAD_EC_FOLLOWUP_LIST_ERROR,


  LOAD_EC_APP,
  LOAD_EC_APP_SUCCESS,
  LOAD_EC_APP_ERROR,

  LOAD_EC_EVENT,
  LOAD_EC_EVENT_SUCCESS,
  LOAD_EC_EVENT_ERROR,

  LOAD_DELIVERABLES,
  LOAD_DELIVERABLES_ERROR,
  LOAD_DELIVERABLES_SUCCESS,

  LOAD_DELIVER_META_DATA,
  LOAD_DELIVER_META_DATA_SUCCESS,
  LOAD_DELIVER_META_DATA_ERROR,

  LOAD_DELIVERABLE_STATUS,
  LOAD_DELIVERABLE_STATUS_ERROR,
  LOAD_DELIVERABLE_STATUS_SUCCESS,

 

  LOAD_ISSUES,
  LOAD_ISSUES_SUCCESS,
  LOAD_ISSUES_ERROR,

  LOAD_CALL_ACTIONS,
  LOAD_CALL_ACTIONS_SUCCESS,
  LOAD_CALL_ACTIONS_ERROR,

  LOAD_CALL_CRITERIA,
  LOAD_CALL_CRITERIA_SUCCESS,
  LOAD_CALL_CRITERIA_ERROR,

  LOAD_DELIVERABLE_TAG,
  LOAD_DELIVERABLE_TAG_SUCCESS,
  LOAD_DELIVERABLE_TAG_ERROR,

  ADD_ISSUES,
  ADD_ISSUES_SUCCESS,
  ADD_ISSUES_ERROR,

  UPDATE_ISSUES,
  UPDATE_ISSUES_SUCCESS,
  UPDATE_ISSUES_ERROR,

  DELETE_ISSUES,
  DELETE_ISSUES_SUCCESS,
  DELETE_ISSUES_ERROR,

  LOAD_CALL_RECORDING,
  LOAD_CALL_RECORDING_SUCCESS,
  LOAD_CALL_RECORDING_ERROR,

  UPDATE_NOTES,
  UPDATE_NOTES_SUCCESS,
  UPDATE_NOTES_ERROR,

  LOAD_REVIEW,
  LOAD_REVIEW_SUCCESS,
  LOAD_REVIEW_ERROR,

  UPDATE_REVIEW,
  UPDATE_REVIEW_SUCCESS,
  UPDATE_REVIEW_ERROR,

  ADD_REVIEW,
  ADD_REVIEW_SUCCESS,
  ADD_REVIEW_ERROR

}

export default constants
